<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{translate?.general.buttons.select2.singular}} {{translate?.preventiveMaintenance.label.singular}} {{translate?.setup.modules.types.label.singular}}</h2>
            <span class="sub">{{translate?.setup.modules.types.messages.chooseWhich}} {{translate?.preventiveMaintenance.fields.maintenance.singular}} {{translate?.setup.modules.types.label.singular | lowercase}} you would like to create</span>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body">
        <div class="pm-type-grid">

            <!-- Card: Time-based -->
            <button class="pm-type-card" type="button" (click)="openPlanBased('Time-based')">
                <div class="pm-type-card__top">
                    <div class="flex-align-center gap-2">
                        <div class="pm-type-card__icon-row">
                            <i class="fa-regular fa-calendar"></i>
                        </div>
                        <div class="pm-type-card__title">{{translate?.maintenancePlan.fields.timeBased.singular}}</div>
                    </div>
                    <p class="pm-type-card__desc">
                        {{translate?.maintenancePlan.fields.maintenance.singular}} {{translate?.maintenancePlan.messages.timeBasedDesc}}
                    </p>
                    <ul class="pm-type-card__bullets">
                        <li>&bull;&nbsp;{{translate?.maintenancePlan.messages.timeBasedBullet1}}</li>
                        <li>&bull;&nbsp;{{translate?.maintenancePlan.messages.timeBasedBullet2}}</li>
                        <li>&bull;&nbsp;{{translate?.maintenancePlan.messages.timeBasedBullet3}}</li>
                    </ul>
                    <p class="pm-type-card__best">
                        <strong>{{translate?.maintenancePlan.messages.bestFor}}</strong>&nbsp;<em>{{translate?.maintenancePlan.messages.timeBasedBestFor}}</em>
                    </p>
                </div>
                <div class="pm-type-card__footer">
                    {{translate?.general.buttons.select2.singular}}
                </div>
            </button>

            <!-- Card: Time + Meter based -->
            <button class="pm-type-card" type="button" (click)="openPlanBased('Time Meter based')">
                <div class="pm-type-card__top">
                    <div class="flex-align-center gap-2">
                        <div class="pm-type-card__icon-row">
                            <i class="fa-regular fa-calendar"></i>
                            <i class="fa-solid fa-chart-simple"></i>
                        </div>
                        <div class="pm-type-card__title">{{translate?.maintenancePlan.fields.time.singular}} + {{translate?.maintenancePlan.fields.meterBased.singular}}</div>
                    </div>
                    <p class="pm-type-card__desc">
                        {{translate?.maintenancePlan.messages.timeMeterBasedDesc}}
                    </p>
                    <ul class="pm-type-card__bullets">
                        <li>&bull;&nbsp;{{translate?.maintenancePlan.messages.timeMeterBasedBullet1}}</li>
                        <li>&bull;&nbsp;{{translate?.maintenancePlan.messages.timeMeterBasedBullet2}}</li>
                        <li>&bull;&nbsp;{{translate?.maintenancePlan.messages.timeMeterBasedBullet3}} {{translate?.asset.label.singular | lowercase}} {{translate?.maintenancePlan.messages.usage}}</li>
                    </ul>
                    <p class="pm-type-card__best">
                        <strong>{{translate?.maintenancePlan.messages.bestFor}}</strong>&nbsp;<em>{{translate?.maintenancePlan.messages.timeMeterBasedBestForStart}} {{translate?.asset.label.singular | lowercase}} {{translate?.maintenancePlan.messages.withRuntimeMeters}}</em>
                    </p>
                </div>
                <div class="pm-type-card__footer">
                    {{translate?.general.buttons.select2.singular}}
                </div>
            </button>

        </div>
    </div>
</div>